const LossAndDamageClaimsTypes = {
  SET_CLAIMS_FILTERS: 'LOSS_AND_DAMAGE.SET_CLAIMS_FILTERS',
  SET_FILTER_TYPE: 'LOSS_AND_DAMAGE.SET_FILTER_TYPE',
  SET_SELECTED_CLAIMS: 'LOSS_AND_DAMAGE.SET_SELECTED_CLAIMS',
  SET_CLAIM_EDIT_DRAWER: 'LOSS_AND_DAMAGE.SET_CLAIM_EDIT_DRAWER',

  GET_CLAIMS_LIST_PROGRESS: 'LOSS_AND_DAMAGE.GET_CLAIMS_LIST_PROGRESS',
  GET_CLAIMS_LIST_SUCCESS: 'LOSS_AND_DAMAGE.GET_CLAIMS_LIST_SUCCESS',
  GET_CLAIMS_LIST_ERROR: 'LOSS_AND_DAMAGE.GET_CLAIMS_LIST_ERROR',
  SET_CLAIMS_LIST: 'LOSS_AND_DAMAGE.SET_CLAIMS_LIST',
  REFRESH_CLAIMS_LIST: 'LOSS_AND_DAMAGE.REFRESH_CLAIMS_LIST',

  DELETE_CLAIMS_PROGRESS: 'LOSS_AND_DAMAGE.DELETE_CLAIMS_PROGRESS',

  GET_CLAIM_DETAILS_PROGRESS: 'LOSS_AND_DAMAGE.GET_CLAIM_DETAILS_PROGRESS',
  GET_CLAIM_DETAILS_SUCCESS: 'LOSS_AND_DAMAGE.GET_CLAIM_DETAILS_SUCCESS',
  GET_CLAIM_DETAILS_ERROR: 'LOSS_AND_DAMAGE.GET_CLAIM_DETAILS_ERROR',

  UPDATE_CLAIM_DETAILS_PROGRESS: 'LOSS_AND_DAMAGE.UPDATE_CLAIM_DETAILS_PROGRESS',

  CREATE_CLAIM_PROGRESS: 'LOSS_AND_DAMAGE.CREATE_CLAIM_PROGRESS',
  CREATE_CLAIM_SUCCESS: 'LOSS_AND_DAMAGE.CREATE_CLAIM_SUCCESS',
  CREATE_CLAIM_ERROR: 'LOSS_AND_DAMAGE.CREATE_CLAIM_ERROR',
  CREATE_CLAIM_RESET: 'LOSS_AND_DAMAGE.CREATE_CLAIM_RESET',

  SEND_EMAIL_TO_CARRIER_PROGRESS: 'LOSS_AND_DAMAGE.SEND_EMAIL_TO_CARRIER_PROGRESS',

  CHECK_EXP_EXPORT_PROGRESS: 'LOSS_AND_DAMAGE.CHECK_EXP_EXPORT_PROGRESS',
  CHECK_EXP_EXPORT_SUCCESS: 'LOSS_AND_DAMAGE.CHECK_EXP_EXPORT_SUCCESS',
  CHECK_EXP_EXPORT_ERROR: 'LOSS_AND_DAMAGE.CHECK_EXP_EXPORT_ERROR',

  SET_CLAIM_SEARCH_VIEW_TYPE: 'LOSS_AND_DAMAGE.SET_CLAIM_SEARCH_VIEW_TYPE',
  SET_CLAIM_SEARCH_VIEW_TYPE_INITIAL: 'LOSS_AND_DAMAGE.SET_CLAIM_SEARCH_VIEW_TYPE_INITIAL',

  GET_TABLE_VIEW_COLUMNS_PROGRESS: 'LOSS_AND_DAMAGE.GET_TABLE_VIEW_COLUMNS_PROGRESS',
  GET_TABLE_VIEW_COLUMNS_SUCCESS: 'LOSS_AND_DAMAGE.GET_TABLE_VIEW_COLUMNS_SUCCESS',
  GET_TABLE_VIEW_COLUMNS_ERROR: 'LOSS_AND_DAMAGE.GET_TABLE_VIEW_COLUMNS_ERROR',

  GET_SORTING_FIELDS_PROGRESS: 'LOSS_AND_DAMAGE.GET_SORTING_FIELDS_PROGRESS',
  GET_SORTING_FIELDS_SUCCESS: 'LOSS_AND_DAMAGE.GET_SORTING_FIELDS_SUCCESS',
  GET_SORTING_FIELDS_ERROR: 'LOSS_AND_DAMAGE.GET_SORTING_FIELDS_ERROR',

  SAVE_TABLE_VIEW_COLUMNS_PROGRESS: 'LOSS_AND_DAMAGE.SAVE_TABLE_VIEW_COLUMNS_PROGRESS',
  SAVE_TABLE_VIEW_COLUMNS_SUCCESS: 'LOSS_AND_DAMAGE.SAVE_TABLE_VIEW_COLUMNS_SUCCESS',
  SAVE_TABLE_VIEW_COLUMNS_ERROR: 'LOSS_AND_DAMAGE.SAVE_TABLE_VIEW_COLUMNS_ERROR',

  VALIDATE_DUPLICATE_CLAIM_PROGRESS: 'LOSS_AND_DAMAGE.VALIDATE_DUPLICATE_CLAIM_PROGRESS',

  GET_CLAIM_NOTES_PROGRESS: 'LOSS_AND_DAMAGE.GET_CLAIM_NOTES_PROGRESS',
  GET_CLAIM_NOTES_SUCCESS: 'LOSS_AND_DAMAGE.GET_CLAIM_NOTES_SUCCESS',
  GET_CLAIM_NOTES_ERROR: 'LOSS_AND_DAMAGE.GET_CLAIM_NOTES_ERROR',

  GET_CLAIM_SETTLEMENTS_PROGRESS: 'LOSS_AND_DAMAGE.GET_CLAIM_SETTLEMENTS_PROGRESS',
  GET_CLAIM_SETTLEMENTS_SUCCESS: 'LOSS_AND_DAMAGE.GET_CLAIM_SETTLEMENTS_SUCCESS',
  GET_CLAIM_SETTLEMENTS_ERROR: 'LOSS_AND_DAMAGE.GET_CLAIM_SETTLEMENTS_ERROR',

  GET_CLAIM_ITEMS_PROGRESS: 'LOSS_AND_DAMAGE.GET_CLAIM_ITEMS_PROGRESS',
  GET_CLAIM_ITEMS_SUCCESS: 'LOSS_AND_DAMAGE.GET_CLAIM_ITEMS_SUCCESS',
  GET_CLAIM_ITEMS_ERROR: 'LOSS_AND_DAMAGE.GET_CLAIM_ITEMS_ERROR',

  GET_CLAIM_EMAIL_STATUS_PROGRESS: 'LOSS_AND_DAMAGE.GET_CLAIM_EMAIL_STATUS_PROGRESS',
  GET_CLAIM_EMAIL_STATUS_SUCCESS: 'LOSS_AND_DAMAGE.GET_CLAIM_EMAIL_STATUS_SUCCESS',
  GET_CLAIM_EMAIL_STATUS_ERROR: 'LOSS_AND_DAMAGE.GET_CLAIM_EMAIL_STATUS_ERROR',

  GET_CLAIM_FILES_PROGRESS: 'LOSS_AND_DAMAGE.GET_CLAIM_FILES_PROGRESS',
  GET_CLAIM_FILES_SUCCESS: 'LOSS_AND_DAMAGE.GET_CLAIM_FILES_SUCCESS',
  GET_CLAIM_FILES_ERROR: 'LOSS_AND_DAMAGE.GET_CLAIM_FILES_ERROR',
};

export default LossAndDamageClaimsTypes;
